export default { buildTime: '2025-11-28T20:22:53+08:00' }